/* eslint-disable */
import { getField, updateField } from 'vuex-map-fields'
import axios from 'axios'

let api = axios.create({
    baseURL: 'https://greenfields.ngrok.io/api/',
    timeout: 400000,
    withCredentials: true
})


// END OF IMPORTS

const state = {
    recaptchaSnackbar: false,
    beefSnackbar: false,
    beefSnackbarText: '',
    form: {
        valid: true,
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        textable: true,
        dropOffFirstName: "",
        dropOffLastName: "",
        dropOffPhone: "",
        cowId: "",
        cutNotes: "",
        thickness: null,
        wrapFor: null,
        roastSize: null,
        groundBeefSize: null,
        standardCut: false,
        rules: {
            nameRules: [v => !!v || "Name is required"],
            phoneRules: [
                v => !!v || "Phone is required",
                v =>
                    /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/.test(
                        v
                    ) || "Must be a 10 digit Phone # (Ex. (123) 456-7890)"
            ],
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+/.test(v) || "E-mail must be valid"
            ],
        },
        lists: {
            thicknessList: [
                "3/4 inch",
                "1 inch (Standard)",
                "1-1/4 inch",
                "1-1/2 inch"
            ],
            wrapForList: ["2 Steaks/Package (Standard)", "4 Steaks/Package"],
            groundBeefSizeList: [
                "1 lb/Package",
                "1.5 lbs/Package (Standard)",
                "2 lbs/Package"
            ],
            roastSizeList: ["2-4 lbs/Roast (Standard)", "4-6 lbs/Roast"],

        },
        typesOfMeat: [
            {
                name: "Chuck Roast",
                id: "chuckRoast",
                value: false,
                src: "static/form-pics/chuck-roast.jpeg"
            },
            {
                name: "Tri-tip",
                id: "triTip",
                value: false,
                src: "static/form-pics/tri-tip.jpeg"
            },
            {
                name: "Stew Meat",
                id: "stew",
                value: false,
                src: "static/form-pics/stew-meat.jpeg"
            },

            {
                name: "Short Ribs",
                id: "shortRibs",
                value: false,
                src: "static/form-pics/short-ribs.jpeg"
            },
            {
                name: "Skirt Steak",
                id: "skirtSteak",
                value: false,
                src: "static/form-pics/skirt-steak.jpeg"
            },
            {
                name: "Flank Steak",
                id: "Flank Steak",
                value: false,
                src: "static/form-pics/flank-steak.jpeg"
            },
            {
                name: "T-Bone & Porterhouse",
                id: "t-Bone",
                value: false,
                src: "static/form-pics/t-bone.jpeg"
            },
            {
                name: "Sirloin Steak",
                id: "sirloin",
                value: false,
                src: "static/form-pics/sirloin.jpeg"
            },
            {
                name: "Rump Roast",
                id: "rump",
                value: false,
                src: "static/form-pics/rump-roast.jpeg"
            },
            {
                name: "Sirloin Tip Roast",
                id: "sirloinTip",
                value: false,
                src: "static/form-pics/sirloin-tip-roast.jpeg"
            },
            {
                name: "Bones",
                id: "bones",
                src: "static/form-pics/bones.jpeg",
                value: false,
                choiceSelected: "Soup Bones",
                choiceQuestion: "Would you like your bones as Soup Bones or Dog Bones?",
                choices: [
                    {
                        name: "Dog Bones",
                        id: "Dog Bones",
                        value: false
                    },
                    {
                        name: "Soup Bones (Standard)",
                        id: "Soup Bones",
                        value: false
                    }
                ]
            },
            {
                name: "Brisket",
                id: "brisket",
                value: false,
                src: "static/form-pics/brisket.jpeg",
                choiceSelected: "Cut in 1/2 (Standard)",
                choiceQuestion: "Would you like Brisket Cut in 1/2 or Left Whole?",
                choices: [
                    {
                        name: "Cut in 1/2 (Standard)",
                        id: "Cut in 1/2 (Standard)",
                        value: false
                    },
                    {
                        name: "Whole",
                        id: "Whole Brisket",
                        value: false
                    }
                ]
            },
            {
                name: "Round Steak",
                id: "roundSteak",
                value: false,
                src: "/static/form-pics/round-steak.jpeg",
                choiceSelected: "1/2 Cubed & 1/2 Steaks (Standard)",
                choiceQuestion: "How would you like your round steaks?",
                choices: [
                    {
                        name: "All Steaks",
                        id: "All Steaks",
                        value: false
                    },
                    {
                        name: "All Cubed",
                        id: "All Cubed",
                        value: false
                    },
                    {
                        name: "1/2 Cubed & 1/2 Steaks (Standard)",
                        id: "1/2 Cubed & 1/2 Steaks (Standard)",
                        value: false
                    }
                ]
            },
            {
                name: "Rib Steaks(Bone-in) or Prime Rib",
                id: "ribSteaksPrimeRib",
                value: false,
                choiceSelected: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                src: "static/form-pics/rib-roast.jpeg",
                choiceQuestion: "Would you like:",
                choices: [
                    {
                        name: "All Rib Steak",
                        id: "All Rib Steak",
                        value: false
                    },
                    {
                        name: "All Prime Rib",
                        id: "All Prime Rib",
                        value: false
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        id: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        value: false,
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        id: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        value: false,
                    }
                ]
            },

        ]
    }
    // END OF STATE
}

const mutations = {
    updateField,
    changeTypesOfMeatToStandard() {
        state.form.typesOfMeat = [
            {
                name: "Chuck Roast",
                id: "chuckRoast",
                value: true,
                src: "static/form-pics/chuck-roast.jpeg"
            },
            {
                name: "Tri-tip",
                id: "triTip",
                value: true,
                src: "/static/form-pics/tri-tip.jpeg"
            },
            {
                name: "Stew Meat",
                id: "stew",
                value: true,
                src: "/static/form-pics/stew-meat.jpeg"
            },

            {
                name: "Short Ribs",
                id: "shortRibs",
                value: true,
                src: "/static/form-pics/short-ribs.jpeg"
            },
            {
                name: "Skirt Steak",
                id: "skirtSteak",
                value: true,
                src: "static/form-pics/skirt-steak.jpeg"
            },
            {
                name: "Flank Steak",
                id: "Flank Steak",
                value: true,
                src: "static/form-pics/flank-steak.jpeg"
            },
            {
                name: "T-Bone & Porterhouse",
                id: "t-Bone",
                value: true,
                src: "/static/form-pics/t-bone.jpeg"
            },
            {
                name: "Sirloin Steak",
                id: "sirloin",
                value: true,
                src: "/static/form-pics/sirloin.jpeg"
            },
            {
                name: "Rump Roast",
                id: "rump",
                value: true,
                src: "/static/form-pics/rump-roast.jpeg"
            },
            {
                name: "Sirloin Tip Roast",
                id: "sirloinTip",
                value: true,
                src: "/static/form-pics/sirloin-tip-roast.jpeg"
            },
            {
                name: "Bones",
                id: "bones",
                src: "static/form-pics/bones.jpeg",
                value: true,
                choiceSelected: "Soup Bones",
                choiceQuestion: "Would you like your bones as Soup Bones or Dog Bones?",
                choices: [
                    {
                        name: "Dog Bones",
                        id: "Dog Bones",
                        value: false
                    },
                    {
                        name: "Soup Bones (Standard)",
                        id: "Soup Bones",
                        value: false
                    }
                ]
            },
            {
                name: "Brisket",
                id: "brisket",
                value: true,
                src: "static/form-pics/brisket.jpeg",
                choiceSelected: "Cut in 1/2 (Standard)",
                choiceQuestion: "Would you like Brisket Cut in 1/2 or Left Whole?",
                choices: [
                    {
                        name: "Cut in 1/2 (Standard)",
                        id: "Cut in 1/2 (Standard)",
                        value: false
                    },
                    {
                        name: "Whole",
                        id: "Whole Brisket",
                        value: false
                    }
                ]
            },
            {
                name: "Round Steak",
                id: "roundSteak",
                value: true,
                src: "/static/form-pics/round-steak.jpeg",
                choiceSelected: "1/2 Cubed & 1/2 Steaks (Standard)",
                choiceQuestion: "How would you like your round steaks?",
                choices: [
                    {
                        name: "All Steaks",
                        id: "All Steaks",
                        value: false
                    },
                    {
                        name: "All Cubed",
                        id: "All Cubed",
                        value: false
                    },
                    {
                        name: "1/2 Cubed & 1/2 Steaks (Standard)",
                        id: "1/2 Cubed & 1/2 Steaks (Standard)",
                        value: false
                    }
                ]
            },
            {
                name: "Rib Steaks(Bone-in) or Prime Rib",
                id: "ribSteaksPrimeRib",
                value: true,
                choiceSelected: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                src: "static/form-pics/rib-roast.jpeg",
                choiceQuestion: "Would you like:",
                choices: [
                    {
                        name: "All Rib Steak",
                        id: "All Rib Steak",
                        value: false
                    },
                    {
                        name: "All Prime Rib",
                        id: "All Prime Rib",
                        value: false
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        id: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        value: false,
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        id: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        value: false,
                    }
                ]
            },

        ]
    },
    changeTypesOfMeatToState() {
        state.form.typesOfMeat = [
            {
                name: "Chuck Roast",
                id: "chuckRoast",
                value: false,
                src: "static/form-pics/chuck-roast.jpeg"
            },
            {
                name: "Tri-tip",
                id: "triTip",
                value: false,
                src: "static/form-pics/tri-tip.jpeg"
            },
            {
                name: "Stew Meat",
                id: "stew",
                value: false,
                src: "static/form-pics/stew-meat.jpeg"
            },

            {
                name: "Short Ribs",
                id: "shortRibs",
                value: false,
                src: "static/form-pics/short-ribs.jpeg"
            },
            {
                name: "Skirt Steak",
                id: "skirtSteak",
                value: false,
                src: "static/form-pics/skirt-steak.jpeg"
            },
            {
                name: "Flank Steak",
                id: "Flank Steak",
                value: false,
                src: "static/form-pics/flank-steak.jpeg"
            },
            {
                name: "T-Bone & Porterhouse",
                id: "t-Bone",
                value: false,
                src: "static/form-pics/t-bone.jpeg"
            },
            {
                name: "Sirloin Steak",
                id: "sirloin",
                value: false,
                src: "static/form-pics/sirloin.jpeg"
            },
            {
                name: "Rump Roast",
                id: "rump",
                value: false,
                src: "static/form-pics/rump-roast.jpeg"
            },
            {
                name: "Sirloin Tip Roast",
                id: "sirloinTip",
                value: false,
                src: "static/form-pics/sirloin-tip-roast.jpeg"
            },
            {
                name: "Bones",
                id: "bones",
                src: "static/form-pics/bones.jpeg",
                value: false,
                choiceSelected: "Soup Bones",
                choiceQuestion: "Would you like your bones as Soup Bones or Dog Bones?",
                choices: [
                    {
                        name: "Dog Bones",
                        id: "Dog Bones",
                        value: false
                    },
                    {
                        name: "Soup Bones (Standard)",
                        id: "Soup Bones",
                        value: false
                    }
                ]
            },
            {
                name: "Brisket",
                id: "brisket",
                value: false,
                src: "static/form-pics/brisket.jpeg",
                choiceSelected: "Cut in 1/2 (Standard)",
                choiceQuestion: "Would you like Brisket Cut in 1/2 or Left Whole?",
                choices: [
                    {
                        name: "Cut in 1/2 (Standard)",
                        id: "Cut in 1/2 (Standard)",
                        value: false
                    },
                    {
                        name: "Whole",
                        id: "Whole Brisket",
                        value: false
                    }
                ]
            },
            {
                name: "Round Steak",
                id: "roundSteak",
                value: false,
                src: "/static/form-pics/round-steak.jpeg",
                choiceSelected: "1/2 Cubed & 1/2 Steaks (Standard)",
                choiceQuestion: "How would you like your round steaks?",
                choices: [
                    {
                        name: "All Steaks",
                        id: "All Steaks",
                        value: false
                    },
                    {
                        name: "All Cubed",
                        id: "All Cubed",
                        value: false
                    },
                    {
                        name: "1/2 Cubed & 1/2 Steaks (Standard)",
                        id: "1/2 Cubed & 1/2 Steaks (Standard)",
                        value: false
                    }
                ]
            },
            {
                name: "Rib Steaks(Bone-in) or Prime Rib",
                id: "ribSteaksPrimeRib",
                value: false,
                choiceSelected: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                src: "static/form-pics/rib-roast.jpeg",
                choiceQuestion: "Would you like:",
                choices: [
                    {
                        name: "All Rib Steak",
                        id: "All Rib Steak",
                        value: false
                    },
                    {
                        name: "All Prime Rib",
                        id: "All Prime Rib",
                        value: false
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        id: "Half Rib Steak/Half Prime Rib (4-6lb Roast) (Standard)",
                        value: false,
                    },
                    {
                        name: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        id: "Half Rib Steak/Half Prime Rib (2-4lb Roast)",
                        value: false,
                    }
                ]
            },

        ]
    },
    resetForm(state) {
        state.form.thickness = null,
            state.form.wrapFor = null,
            state.form.roastSize = null,
            state.form.groundBeefSize = null,
            state.form.standardCut = false,
            state.form.cowId = "",
            state.form.cutNotes = ""
    },
    changeBeefSaveSnackbarToTrue(state) {
        state.beefSnackbarText = 'Cut Sheet has been sent successfully. A copy has been sent to the email you provided as well. Please check your spam if you do not see it in the next couple of minutes. Thank you for choosing Greenfield Custom Meat!'
        state.beefSnackbar = true
    },
    // END OF MUTATIONS
}

const actions = {
    // recaptcha(body, recaptchaBody) {
    //     api.post('recaptcha', recaptchaBody).then(res => {
    //         var data = res.data.data
    //         console.log('data.hostname :>> ', data.hostname);
    //         if (data.success && data.hostname == 'greenfieldcustommeat.com' && data.score >= .5 && data.action == 'login') {
    //             console.log('pass', data.score)
    //             body.secret = recaptchaBody.secret
    //             this.changeBody(body)
    //         } else {
    //             // console.log('fail', data.score)
    //             return dispatch.changeRecaptchaSnackbarToTrue()
    //         }

    //     }).catch(handleError)
    // },
    postBeefCutSheet({ commit }, body) {
        console.log('body :>> ', body);
        api.post('beefcutsheets', body).then(res => {
            state.res = res
            commit('changeBeefSaveSnackbarToTrue')
            return setTimeout(() => {
                commit('changeTypesOfMeatToState')
                commit('resetForm')
            }, 7000);
        }).catch(err => {
            console.log('err :>> ', err);
        })
    },
    changeBody({ dispatch }, body) {
        var meat = body.typesOfMeat
        // Boolean
        body.chuckRoast = meat[0].value
        body.triTip = meat[1].value
        body.stewMeat = meat[2].value
        body.shortRibs = meat[3].value
        body.skirtSteak = meat[4].value
        body.flankSteak = meat[5].value
        body.tBoneAndPorterHouse = meat[6].value
        body.sirlionSteak = meat[7].value
        body.rumpRoast = meat[8].value
        body.sirlionTipRoast = meat[9].value
        //strings
        body.bones = (meat[10].value) ? meat[10].choiceSelected : "No Selection Made",
            body.brisket = (meat[11].value) ? meat[11].choiceSelected : "No Selection Made",
            body.roundSteak = (meat[12].value) ? meat[12].choiceSelected : "No Selection Made",
            body.ribSteaksOrPrimeRib = (meat[13].value) ? meat[13].choiceSelected : "No Selection Made",
            dispatch('postBeefCutSheet', body)
    }
    // END OF ACTIONS
}

const getters = {
    getField,
    getform: state => {
        return state.form
    },
    // END OF GETTERS
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
